// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Message_Gravity } from "../logger/logger.js";
import { OccViewer } from "../viewer/viewer.js";
/**
 * Update [[ModelLoader]] in OccViewer.
 * @internal
 */
OccViewer.onInit((theModule) => {
    let aController = theModule.modelLoader;
    aController.openFromUrl = function (theName, theFileUrl, theToExpand) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            let aFilePath = theName.length > 0 && theName[0] == "/" ? theName : "/" + theName;
            let aPathSplit = (_a = theFileUrl.split("/").pop()) === null || _a === void 0 ? void 0 : _a.split(".").pop();
            if (aPathSplit != null) {
                aFilePath += "." + aPathSplit;
            }
            yield this.uploadUrl(theFileUrl, aFilePath, false);
            return this.openFromFile(theName, aFilePath, theToExpand);
        });
    };
    aController.openFromFile = function (theName, theFilePath, theToExpand) { return this._cppOpenFromFile(theName, theFilePath, theToExpand); };
    aController.openFromMemory = function (theName, theBuffer, theToExpand) {
        let aDataArray = new Uint8Array(theBuffer);
        const aDataBuffer = theModule["_malloc"](aDataArray.length);
        //@ts-ignore
        theModule["HEAPU8"].set(aDataArray, aDataBuffer.byteOffset);
        let aRes = 
        //@ts-ignore
        this._cppOpenFromMemory(theName, theToExpand, aDataBuffer.byteOffset, aDataArray.length);
        //this._free (aDataBuffer); will be freed by called method
        return aRes;
    };
    aController.preloadFile = function (theBuffer, theFilePath, theToPreload) {
        return new Promise((theResolve, theReject) => {
            let aDestDir = theModule["PATH"].dirname(theFilePath);
            theModule["FS"].mkdirTree(aDestDir);
            theModule["FS"].writeFile(theFilePath, theBuffer);
            if (theToPreload) {
                // decode image
                theModule["FS"].createPreloadedFile(!theFilePath.startsWith("/") ? theModule["FS"].cwd() : "/", theFilePath, theBuffer, true, true, () => {
                    theResolve(true);
                }, () => {
                    theReject(new Error("Preload '" + theFilePath + "' failed"));
                }, true); // file is already created
            }
            else {
                theResolve(true);
            }
        });
    };
    aController.uploadUrl = function (theFileUrl, theFilePath, theToPreload) {
        let aPathSplit = theFileUrl.split("/");
        let aFileName = theFileUrl;
        if (aPathSplit.length > 1) {
            aFileName = aPathSplit[aPathSplit.length - 1];
        }
        let aFilePath = theFilePath;
        if (aFilePath === "") {
            aFilePath = aFileName;
        }
        const aCheckStatusFunc = function (theResponse) {
            if (!theResponse.ok) {
                throw new Error("HTTP " + theResponse.status + " - " + theResponse.statusText
                    + " (URL: '" + theFileUrl + "')");
            }
            return theResponse;
        };
        return new Promise((theResolve, theReject) => {
            fetch(theFileUrl)
                .then((theResponse) => aCheckStatusFunc(theResponse) && theResponse.arrayBuffer())
                .then((theBuffer) => {
                let aDataArray = new Uint8Array(theBuffer);
                theModule.printMessage("uploading file '" + aFileName + "' of size "
                    + aDataArray.length + " bytes to '" + aFilePath
                    + "'...", Message_Gravity.Message_Trace.valueOf());
                this.preloadFile(aDataArray, aFilePath, theToPreload)
                    .then((aData) => {
                    theResolve(aData);
                })
                    .catch((anErr) => {
                    theReject(anErr);
                });
            })
                .catch((theErr) => {
                theReject(theErr);
            });
        });
    };
    aController.unlinkFile = function (theFilePath) {
        const aRes = theModule["FS"].analyzePath(theFilePath, true);
        if (aRes.exists) {
            theModule["FS"].unlink(theFilePath);
            return true;
        }
        else {
            return false;
        }
    };
});
